import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { corningConfig } from "./data";

export default function CorningPage() {
  return <CityPageTemplate config={corningConfig} />;
}